module.exports = "../fonts/PTS55F.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/PTS55F.ttf
// module id = 580
// module chunks = 0